import { render, staticRenderFns } from "./WebinarEdit.vue?vue&type=template&id=961f6a3e&scoped=true&"
import script from "./WebinarEdit.vue?vue&type=script&lang=js&"
export * from "./WebinarEdit.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"
import style1 from "./WebinarEdit.vue?vue&type=style&index=1&id=961f6a3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "961f6a3e",
  null
  
)

export default component.exports